import { render, staticRenderFns } from "./ElderHealth.vue?vue&type=template&id=2f67c862&scoped=true&"
import script from "./ElderHealth.vue?vue&type=script&lang=js&"
export * from "./ElderHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67c862",
  null
  
)

export default component.exports